import $ from 'jquery';
import BLazy from 'blazy';
import Cookie from 'js-cookie';
import App, { renderSearchList, fillBasket, ifDropdownBasketEmpty } from './App';
import { IconWishlist } from './Icons';
import { Alert } from './Alert';
import GetFunction, { Get } from './Get';
import { Validation } from './Validation';
import { Recaptcha } from './Recaptcha';
import ForAdult from './ForAdult';
import { queryApi, getQueryMenuProduct } from './Query';

const init = () => {
  /* eslint-disable */
  (function ($) {
    'use strict';
    var backdrop = '.dropdown-backdrop';
    var toggle = '[data-toggle="dropdown"]';
    var Dropdown = function (element) {
      $(element).on('click.bs.dropdown', this.toggle);
    };
    Dropdown.VERSION = '3.3.6';
    function getParent($this) {
      var selector = $this.attr('data-target');
      if (!selector) {
        selector = $this.attr('href');
        selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '');
      }
      var $parent = selector && $(selector);
      return $parent && $parent.length ? $parent : $this.parent();
    }
    function clearMenus(e) {
      if (e && e.which === 3) return;
      $(backdrop).remove();
      $(toggle).each(function () {
        var $this = $(this);
        var $parent = getParent($this);
        var relatedTarget = { relatedTarget: this };
        if (!$parent.hasClass('open')) return;
        if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target))
          return;
        $parent.trigger((e = $.Event('hide.bs.dropdown', relatedTarget)));
        if (e.isDefaultPrevented()) return;
        $this.attr('aria-expanded', 'false');
        $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
      });
    }
    Dropdown.prototype.toggle = function (e) {
      var $this = $(this);
      if ($this.is('.disabled, :disabled')) return;
      var $parent = getParent($this);
      var isActive = $parent.hasClass('open');
      clearMenus();
      if (!isActive) {
        if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
          $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
        }
        var relatedTarget = { relatedTarget: this };
        $parent.trigger((e = $.Event('show.bs.dropdown', relatedTarget)));
        if (e.isDefaultPrevented()) return;
        $this.trigger('focus').attr('aria-expanded', 'true');
        $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
      }
      return false;
    };
    Dropdown.prototype.keydown = function (e) {
      if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
      var $this = $(this);
      e.preventDefault();
      e.stopPropagation();
      if ($this.is('.disabled, :disabled')) return;
      var $parent = getParent($this);
      var isActive = $parent.hasClass('open');
      if ((!isActive && e.which != 27) || (isActive && e.which == 27)) {
        if (e.which == 27) $parent.find(toggle).trigger('focus');
        return $this.trigger('click');
      }
      var desc = ' li:not(.disabled):visible a';
      var $items = $parent.find('.dropdown-menu' + desc);
      if (!$items.length) return;
      var index = $items.index(e.target);
      if (e.which == 38 && index > 0) index--;
      if (e.which == 40 && index < $items.length - 1) index++;
      if (!~index) index = 0;
      $items.eq(index).trigger('focus');
    };
    function Plugin(option) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data('bs.dropdown');
        if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)));
        if (typeof option == 'string') data[option].call($this);
      });
    }
    var old = $.fn.dropdown;
    $.fn.dropdown = Plugin;
    $.fn.dropdown.Constructor = Dropdown;
    $.fn.dropdown.noConflict = function () {
      $.fn.dropdown = old;
      return this;
    };
    $(document)
      .on('click.bs.dropdown.data-api', clearMenus)
      .on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
        e.stopPropagation();
      })
      .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
      .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
      .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
  })($);
  /* eslint-enable */
  /* eslint-disable import/prefer-default-export */
  /* eslint-disable prefer-arrow-callback */
  /* eslint-disable camelcase */
  /* eslint-disable no-loop-func */
  /* eslint-disable consistent-return */
  /* eslint-disable no-restricted-globals */
  /* eslint-disable no-plusplus */
  /* eslint-disable no-restricted-syntax */
  /* eslint-disable guard-for-in */
  /* eslint-disable no-undef */
  /* eslint-disable no-eval */
  /* eslint-disable eqeqeq */
  /* eslint-disable prefer-template */

  const forAdult = new ForAdult();

  $('.html-placeholder').each(function placeholderEach() {
    const self = $(this);

    if (self.data('selector') && $(self.data('selector')).length) {
      self.replaceWith($(self.data('selector')));
    }
  });

  $('#menu_orders .headline, #menu_account .headline, #menu_regulations .headline').on(
    'click',
    function footerMenuHeadlineClick() {
      if (App.vars.view === 1) {
        const self = $(this);
        if (self.next().hasClass('footer__sublist')) {
          self.toggleClass('--open');
          self.next().slideToggle('slow');
          return false;
        }
      }
      return true;
    },
  );

  $('.menu__search label').on('click', function menuSearchLabeLClick() {
    $('html').addClass('search_open');
    $('#menu_search input').focus();
  });

  $('.menu__search .--close').on('click', function menuSearchCloseClick() {
    $('#menu_search input').val('');
    $('.menu__search-result').remove();
    $('.menu__search, #menu_categories').removeClass('--loaded');
    $('html').removeClass('search_open');
    return false;
  });

  $('#menu_settings').on('mouseover', function menuSearchCloseHover() {
    $('.menu__search-result').remove();
    $('.menu__search, #menu_categories').removeClass('--loaded');
    $('html').removeClass('search_open');
  })

  $('.menu__search .f-control').on('keyup focus', function menuSearchInputKeyup() {
    const self = this;

    if (self.value.length === 0) {
      // $('.menu__search-result').remove();
      $('.menu__search, #menu_categories').removeClass('--loaded');
    }

    if (!$('.menu__search-result').length) {
      const html = '<div class="menu__search-result"></div>';
      $('.menu__search').append(html);
    }

    clearTimeout(App.vars.searchTimeout);
    App.vars.searchTimeout = setTimeout(() => renderSearchList(self.value, '.menu__search-result'), 500);
  });

  $(document).on('keyup blur change', '.f-control.--validate-input', function changeInputValidation() {
    clearTimeout(App.vars.validationTimeout);
    App.vars.validationTimeout = setTimeout(() => Validation.validateInput(this, this.dataset.validate), 500);
  });

  $(document).on('submit', '.--validate-form', function submitValidateForm(event) {
    Validation.validateForm(event, [...this.querySelectorAll('.--validate-input')]);
  });

  $(document).on('click', 'aside .menu__settings .--trigger', function settingsTriggerClick() {
    const self = $(this);
    const next = self.next();
    if (next.length && next.hasClass('menu__settings-form')) {
      $('.menu__helps .--open').removeClass('--open');
      next.toggleClass('--open');
    }
  });

  $(document).on('click', 'aside .menu__helps .--help-toggler', function settingsTriggerClick() {
    const self = $(this);
    const next = self.next();
    if (next.length && next.hasClass('menu__expand')) {
      $('.menu__settings .--open').removeClass('--open');
      next.toggleClass('--open');
    }
  });

  $(document).on('click', 'aside .nav-item > .nav-link', function asideNavLinkClick(e) {
    const self = $(this);
    if (self.next().hasClass('navbar__wrapper')) {
      self.next().scrollTop(0).addClass('--open');
      e.preventDefault();
    }
    if (self.hasClass('--has-child')) {
      self
        .parents('.navbar__wrapper')
        .find(`.navbar-subsubnav[data-child_id=${self.data('child')}]`)
        .scrollTop(0)
        .addClass('--open');
      e.preventDefault();
    }
  });

  $(document).on('click', '.nav-header', function asideNavHeaderClick(e) {
    e.preventDefault();
    $(this).closest('.--open').removeClass('--open');
  });

  // $(document).on('click', 'header .navbar-nav > .nav-item', function headerNavLinkClick(e) {
  //   const self = $(this);
  //   $('.--hover').removeClass('--hover');
  //   self.addClass('--hover');
  //   $('#menu_categories').addClass('--hover');
  //   let counter = self.attr('data-click');
  //   if (!counter) {
  //     $('*[data-click]').removeAttr('data-click');
  //     self.attr('data-click', 1);
  //     e.preventDefault();
  //   }
  // })

  // $(document).on('click', function clicktoCloseMenuNavigation(e) {
  //   if ($('.--hover').length) {
  //     if (e.target.closest('#menu_categories')) {
  //       return true;
  //     }
  //     $('.--hover').removeClass('--hover');
  //     $('*[data-click]').removeAttr('data-click');
  //   }
  //   return true;
  // });

  $(document).on('click', function clicktoCloseMenuSearchResult(e) {
    if ($('.menu__search-result').length) {
      if (e.target.closest('.menu__search')) {
        return true;
      }
      $('.menu__search-result').remove();
      $('.menu__search, #menu_categories').removeClass('--loaded');
    }
    return true;
  });

  const createRecommended = (product) => {
    const [productMark, ...productName] = product.name.split(' ')
    return `
      <figure class="product__icon">
        <a class="product__icon-link" href="${product.link}">
          <img src="${product.icon}" />
        </a>
        <div class="trustmate-reviews"></div>
      </figure>
      <small class="product__name_firm">${productMark}</small>
      <a class="product__name" href="${product.link}" title="${product.name}">${productName.join(' ').split()}</a>
      ${product.price.omnibusPrice.gross ? `<div class="product__prices-omnibus mb-3">${window.Literals.product.omnibusText} <span>${product.price.omnibusPrice.gross.formatted}</span></div>` : ''}
      <div class="product__details">                  
        <div class="product__prices">
          ${
            product.price.max
              ? `<del class="price --maxprice">${product.price.max.gross.formatted}</del>`
              : ''
          }
          <strong class="price">${product.price.price.gross.formatted}</strong>
        </div>
        <div class="product__actions">
          <button type="button" class="btn --solid --secondary --wishlist" data-mode="2" data-product="${
            product.id
          }">
            ${IconWishlist}
          </button>
          <button type="button" class="btn --solid --cart" data-product="${product.id}">
            ${Literals.projector.addToBasket}
          </button>
        </div>
      </div>
    `;
  }


  let productTimeout;
  const productTimer = 150;
  const getMenuProduct = async (id, productWrapper) => {
    App.vars.loadingRecommended = id;
    const lang = document.querySelector('#menu_settings input[name="lang"]:checked');
    // Fix for Ostrovit.de
    let singleLang = '';
    const domain = window.location.hostname.split('.')[1];
    if (domain === 'de') {
      singleLang = 'ger';
    } else if (domain === 'it') {
      singleLang = 'ita';
    } else if (domain === 'ue') {
      singleLang = 'ukr';
    }
    const currLang = lang ? lang.value : singleLang;
    clearTimeout(productTimeout);
    productTimeout = await setTimeout(async () => {
      if (App.vars.loadingRecommended === id) {
        const { data } = await queryApi(getQueryMenuProduct(id));
        if (data) {
          if (!data.products.products) {
            productWrapper.removeClass('d-md-block');
            productWrapper.next().removeClass('d-md-block');
            return false;
          }
          const product = data.products.products[0];
          const product2 = data.products.products[1];
          productWrapper.find('.product').html(createRecommended(product));
          // sessionStorage.setItem(`recommended_${currLang}_${id}`, JSON.stringify(product));
          productWrapper.next().find('.product').html(createRecommended(product2));
          // sessionStorage.setItem(`recommended_${currLang}_${id}_2`, JSON.stringify(product2));
        }
      }
    }, 200);
  }

  $(document).on('mouseenter', 'header .nav-product, header .navbar-subnav--right', function clearTimeoutOnProductHover() {
    clearTimeout(productTimeout);
    clearTimeout(subMenuTimeout);
  })
  
  $(document).on('mouseenter', 'header .navbar-nav > .nav-item > .nav-link', async function getAjaxLinkProducts() {
    const self = $(this).parent();
    const product = self.find('.nav-product').first();
    const productWrapper = product.find('.product');
    product.addClass('d-md-block');
    product.next().addClass('d-md-block');
    const lang = document.querySelector('#menu_settings input[name="lang"]:checked');
    const currLang = lang ? lang.value : 'ger';
    // const recommended = sessionStorage.getItem(`recommended_${currLang}_${self.data().id}`);
    // const recommended2 = sessionStorage.getItem(`recommended_${currLang}_${self.data().id}_2`);

    if (productWrapper.length) {
      App.vars.loadingRecommended = self.data().id;
      clearTimeout(productTimeout);
      productTimeout = setTimeout(() => {
        getMenuProduct(self.data().id, productWrapper.parent('.nav-product'));
      }, productTimer)
    }

    // if (productWrapper.length && recommended) {
    //   productWrapper.html(createRecommended(JSON.parse(recommended)));
    // }

    // if (product.next().find('.product').length && recommended2) {
    //   product.next().find('.product').html(createRecommended(JSON.parse(recommended2)));
    // }
  });

  const changeIcon = (icon) => {
    const currSrc = icon.attr('src');
    const currAlt = icon.data('alt');
    icon.attr('src', currAlt);
    icon.data('alt', currSrc);
  }

  $(document).on('mouseenter', 'header .navbar-nav > .nav-item > .nav-link', function changeOnEnterIcon() {
    const icon = $(this).find('img');
    changeIcon(icon);
  });

  $(document).on('mouseleave', 'header .navbar-nav > .nav-item > .nav-link', function changeOnLeaveIcon() {
    const icon = $(this).find('img');
    changeIcon(icon);
  });

  $(document).on('mouseenter', 'header .navbar-subnav > .nav-item', async function getAjaxSubProducts() {
    const self = $(this);
    const product = self.parent().siblings('.navbar-subnav--right').find('.nav-product').first();
    const productWrapper = product.find('.product');
    product.addClass('d-md-block');
    product.next().addClass('d-md-block');
    const recommended = sessionStorage.getItem(`recommended_${self.data().id}`);
    const recommended2 = sessionStorage.getItem(`recommended_${self.data().id}_2`);

    if (productWrapper.length && !recommended) {
      App.vars.loadingRecommended = self.data().id;
      clearTimeout(productTimeout);
      productTimeout = setTimeout(() => {
        getMenuProduct(self.data().id, productWrapper.parent('.nav-product'));
      }, productTimer)
    }

    if (productWrapper.length && recommended) {
      productWrapper.html(createRecommended(JSON.parse(recommended)));
    }

    if (product.next().find('.product').length && recommended2) {
      product.next().find('.product').html(createRecommended(JSON.parse(recommended2)));
    }
  });

  $(document).on('mouseenter', 'header .navbar-subsubnav .nav-item', async function getAjaxSubProducts() {
    const self = $(this);
    const product = self.parents('.navbar-subnav--right').find('.nav-product').first();
    const productWrapper = product.find('.product');
    product.addClass('d-md-block');
    product.next().addClass('d-md-block');
    const recommended = sessionStorage.getItem(`recommended_${self.data().id}`);
    const recommended2 = sessionStorage.getItem(`recommended_${self.data().id}_2`);

    if (productWrapper.length && !recommended) {
      App.vars.loadingRecommended = self.data().id;
      clearTimeout(productTimeout);
      productTimeout = setTimeout(() => {
        getMenuProduct(self.data().id, productWrapper.parent('.nav-product'));
      }, productTimer)
    }

    if (productWrapper.length && recommended) {
      productWrapper.html(createRecommended(JSON.parse(recommended)));
    }

    if (product.next().find('.product').length && recommended2) {
      product.next().find('.product').html(createRecommended(JSON.parse(recommended2)));
    }
  });

  let subMenuTimeout;
  const subMenuTimer = 150;
  $(document).on('mouseenter', 'header .navbar-subnav > .nav-item > .nav-link', function submenuLinkMouseEnter() {
    clearTimeout(subMenuTimeout);
    subMenuTimeout = setTimeout(() => {
      $('.navbar-subsubnav.--active').removeClass('--active');
      $('.nav-link.--hover').removeClass('--hover');
      $(this).addClass('--hover');
      $(`.navbar-subsubnav[data-child_id=${$(this).data('child')}]`).addClass('--active');
    }, subMenuTimer)
  });

  $(document).on('mouseenter', 'header .navbar-subsubnav.--active', function subsubmenuLinkMouseEnter() {
    clearTimeout(subMenuTimeout);
  });

  $(document).on('mouseleave', 'header .navbar__wrapper', function submenuLinkMouseLeave() {
    clearTimeout(subMenuTimeout);
    subMenuTimeout = setTimeout(() => {
      $('.nav-link.--hover').removeClass('--hover');
      $('.navbar-subsubnav.--active').removeClass('--active');
    }, subMenuTimer)
  });

  $(document).on('click', '.navbar-toggler', function navbarTogglerClick(e) {
    e.preventDefault();
    App.fn.mobileMenuGen();

    if ($('html').hasClass('filters_open') || $('html').hasClass('sidebar_open')) {
      $('html').removeClass('filters_open').removeClass('sidebar_open');
      $('#menu_navbar .--open, #menu_settings .--open').removeClass('--open');
    } else {
      $('html').addClass('sidebar_open');
    }
    $('aside .navbar-subnav, aside .navbar-subsubnav, aside, #menu_settings form').scrollTop(0);
    return false;
  });

  $(document).on('click', '.product__actions .--wishlist', function clickAddWishList() {
    const self = $(this);
    self.addClass('--loading');
    const request = `/basketchange.php?product=${self.data('product')}&size=uniw&mode=2&getAjax=true${
      self.hasClass('--observed') ? '&change=empty' : ''
    }`;

    $.ajax({
      type: 'GET',
      url: request,
      success: () => {
        Alert.show({
          text: self.hasClass('--observed') ? Literals.projector.removedWishes : Literals.projector.addedWishes,
          mod: '--success',
          duration: 2500,
        });
        const GetWhishes = new GetFunction();
        GetWhishes.Wishlist(({ Wishlist }) => {
          $('.menu__link.--list .counter').removeClass('--empty');
          $('.menu__link.--list .counter').text(Wishlist.response ? Wishlist.response.product.length : '');
        });
        GetWhishes.init();
        self.toggleClass('--observed');
        self.removeClass('--loading');
      },
    });
  });

  // Dodawanie el. do koszyka
  $(document).on('click', '.product__actions .--cart', function clickAddBasket() {
    const self = $(this);
    const product = self.data('product');

    const onClickBasket = () => {
      forAdult.closeModal();
      self.addClass('--loading');
      const data = `product=${product}&size=uniw&number=1&getAjax=true`;
      const reload = self.hasClass('--reload');
  
      $.ajax({
        type: 'POST',
        url: '/basketchange.php',
        data,
        dataType: 'JSON',
        success: ({ basket }) => {
          Alert.show({ text: Literals.projector.addedProductBasket, mod: '--success', duration: 2500 });
          if (reload) {
            const basketForm = $('.basket__form');
            if (basketForm.length) {
              basketForm.submit();
            } else {
              location.reload();
            }
            return false;
          }
          if (basket.products.length) {
            $('.menu__link.--basket .counter').removeClass('--empty');
            let count = 0;
            basket.products.forEach((product) => count += product.count)
            $('.menu__link.--basket .counter').text(count);
            fillBasket(basket); // stwórz nową zawartość koszyka
          }
          self.removeClass('--loading');
        },
      });

    }

    if (window.forAdultProducts && window.forAdultProducts.includes(Number(product))) {
      forAdult.openModal(onClickBasket);
      return;
    }

    onClickBasket();
  });

  // Usuwanie el. z koszyka
  $(document).on('click', '.basket__action .--cart.--delete', function clickRemoveBasket() {
    const self = $(this);
    const deletedEl = $(".basket__block[data-product-id='" + self.data('product') + "']");
    deletedEl.addClass('to-delete'); // klasa do animacji usunięcia

    const data = `product=${self.data('product')}&size=uniw&mode=1&getAjax=true&change=empty`;

    $.ajax({
      type: 'POST',
      url: '/basketchange.php',
      data,
      dataType: 'JSON',
      success: ({ basket }) => {
        if (basket.products.length) {
          fillBasket(basket); // stwórz nowy koszyk po usunięciu przedmiotu
          let count = 0;
          basket.products.forEach((product) => count += product.count)
          $('.menu__link.--basket .counter').text(count);
        } else {
          ifDropdownBasketEmpty(); // jeśli brak produktów ukryj elementy (cena, przyciski itd.) i wyświetl treść pustego koszyka
          $('.menu__link.--basket .counter').addClass('--empty');
        }
      },
    });
  });

  $(document).on('change input focus blur', '.form-group .form-control, .f-group .f-control', App.fn.addFocused);
  $('.form-group .form-control, .f-group .f-control').each(App.fn.addFocused);

  setTimeout(() => {
    $('.form-group .form-control, .f-group .f-control').each(App.fn.addFocused);
    // TODO: Weryfikacja mechanizmu
    // $('.f-group .f-control.--validate-input').each(function validateAfterSomeTimeout() {
    //   if (this.value) {
    //     Validation.validateInput(this, this.dataset.validate);
    //   }
    // });
  }, 500);

  $('.f-group.--file .f-control').on('change', function fileInputChange() {
    const self = $(this);
    const sibling = self.siblings('.f-label');
    if (self.val().length) {
      sibling.addClass('--file');
      if (!sibling.attr('data-label')) {
        sibling.attr('data-label', sibling.text());
      }
      sibling.text(self.val());
    } else {
      sibling.removeClass('--file');
      sibling.text(sibling.attr('data-label'));
    }
  });

  App.fn.replaceSelects($('.f-select'), '', ($elem) => {
    App.fn.dropdownClick($elem, false);
  });

  App.fn.rwdBanner('#menu_banners2', [1, 2, 3, 4, 5]);

  App.vars.bLazy = new BLazy({
    breakpoints: [{ width: 420, src: 'data-src-small' }],
    offset: 500,
    success: function bLazySuccesFunc(element) {
      $(element).closest('.--skeleton').removeClass('--skeleton');
      $(element).parent().addClass('--loaded');
    },
  });

  Get.Basket(({ Basket }) => {
    if (!Basket) {
      return;
    }
    let count = 0;
    Basket.response.basket.products.forEach((product) => count += product.count)
    $('.menu__link.--basket .menu__link-top').append(`<span class="counter ${!Basket.response.basket.products.length ? '--empty' : ''}">${count}</span>`);

    if (!Basket || !Basket.response.basket.products.length) {
      const basketProductList = document.getElementById('basket__product-list');
      if (basketProductList) {
        Array.from(basketProductList.children).forEach((e) => {
          if (e.classList.contains('loader') || e.classList.contains('basket__empty')) {
            e.classList.toggle('--empty');
          }
        });
      }
      return;
    }

    App.vars.Basket = Basket.response.basket;

    if (document.getElementsByClassName('menu__dropdown-basket').length) {
      fillBasket(Basket);
    }
  });

  Get.Wishlist(({ Wishlist }) => {
    if (!Wishlist) {
      return;
    }
    App.vars.Wishlist = Wishlist.response;
    $('.menu__link.--list').append(`<span class="counter ${!Wishlist.response ? '--empty' : ''}">${Wishlist.response ? Wishlist.response.product.length : 0}</span>`);
  });

  Get.Snippets(
    ({ Snippets }) => {
      if (!Snippets) {
        return;
      }
      const snippets = Snippets.response.items;
      for (const key in snippets) {
        switch (snippets[key].region) {
          case 'head':
            $('head').append(snippets[key].content);
            break;
          case 'body_top':
            $('body').prepend(snippets[key].content);
            break;
          default:
            $('body').append(snippets[key].content);
            break;
        }
      }
    },
    {
      mobile: (App.vars.view == 1).toString(),
      tablet: (App.vars.view == 2).toString(),
      pc: (App.vars.view >= 3).toString(),
      request_uri: App.vars.request_uri,
      additional_ajax: App.vars.additional_ajax,
    },
  );

  Get.ToplayersAndWidgets(
    ({ ToplayersAndWidgets }) => {
      if (!ToplayersAndWidgets) {
        return;
      }
      const tAndW = ToplayersAndWidgets.response.items;
      for (const key in tAndW) {
        if (key === 'script') {
          eval(tAndW[key]);
        } else {
          $('body').append(tAndW[key].content);
        }
      }
    },
    {
      mobile: (App.vars.view == 1).toString(),
      tablet: (App.vars.view == 2).toString(),
      pc: (App.vars.view >= 3).toString(),
      request_uri: App.vars.request_uri,
      additional_ajax: App.vars.additional_ajax,
    },
  );

  const getCookiesProductData = async (id) => {
    const data = {
      Product: {
        format: 'json',
        params: {
          products: id,
        },
      },
    };
    const url = `/ajax/get.php?request=${JSON.stringify(data)}`;
    const resp = await fetch(url);
    const json = await resp.json();
    const {
      Product: {
        response: {
          product: [
            {
              attributes: { link },
              name,
              icon_small,
              price: {
                attributes: { price_formatted },
              },
            },
          ],
        },
      },
    } = json;
    return {
      link,
      name,
      icon_small,
      price_formatted,
    };
  };

  $(document).ready(function () {
    const userInfo = Cookie.get('login');
    const cookiesBar = Cookie.get('ck_cook');
    if (userInfo) {
      $('#ck_dsclr_v2').addClass('d-none');
    } else if (cookiesBar !== 'yes') {
      const cookiesProduct = $('.c-product').attr('data-id');
      if (cookiesProduct) {
        getCookiesProductData(cookiesProduct).then((data) => {
          const { link, name, icon_small, price_formatted } = data;
          $('.c-product__icon').html(`<img src="${icon_small}" alt="${name}">`);
          $('.c-product__name, .c-product__icon').attr({
            href: link,
            title: name,
          });
          $('.c-product__name').text(name);
          $('.c-product .btn, .c-product__link').attr('href', link);
          $('.c-product__price').text(price_formatted);
          $('.c-product').removeClass('--skeleton');
        });
      }
    }
  });


  App.run(
    () => {
      const products = document.querySelectorAll('.hotspot .product__name_wrapper');
      products.forEach((product) => {
        const link = product.querySelector('.product__name');
        const name = link.innerHTML;
        if (name.indexOf('OstroVit Pharma') > -1) {
          if (product.querySelector('.product__name_firm'))
            product.querySelector('.product__name_firm').remove();
          const firm = document.createElement('SMALL');
          firm.classList.add('product__name_firm');
          firm.innerHTML = 'Ostrovit Pharma';
          product.before(firm);
          link.innerHTML = name.substr(15);
          return;
        }
        if (name.indexOf('OstroVit') > -1) {
          if (product.querySelector('.product__name_firm'))
            product.querySelector('.product__name_firm').remove();
          const firm = document.createElement('SMALL');
          firm.classList.add('product__name_firm');
          firm.innerHTML = 'Ostrovit';
          product.before(firm);
          link.innerHTML = name.substr(9);
        }
      })
    },
    'all',
    '.hotspot .product__name_wrapper',
    true
  );


  App.run(
    () => {
      App.fn.mobileMenuGen(true);

      if ($('.navbar__wrapper .--bottom .--label').length) {
        $('.navbar__wrapper').each(function moveLabelToOtherPlaceEach() {
          const self = $(this);
          const link = self.find('.nav-product .--label');

          if (link.length) {
            self.find('.--bottom').append(link);
          }
        });
      }
    },
    [3, 4, 5],
    'body',
  );

  const Captcha = new Recaptcha('.--captchable');
  Captcha.setEventsInput();

  App.run(() => {
    if (!$('.navbar__wrapper .--bottom .--label').length) {
      $('.navbar__wrapper').each(function moveLabelToOtherPlaceEach() {
        const self = $(this);
        const link = self.find('.nav-product .--label');

        if (link.length) {
          self.find('.--bottom').append(link);
        }
      });
    }
  }, [1, 2]);

  App.run(
    () => {
      $('.newsletter:not(.--black) .--top .f-group').after($('.newsletter:not(.--black) .--consent'));
      $('.newsletter.--black .--top .f-group').after($('.newsletter.--black .--consent'));
    },
    [1],
    '.newsletter',
  );

  App.run(
    () => {
      $('.newsletter:not(.--black) .--top').after($('.newsletter:not(.--black) .--consent'));
      $('.newsletter.--black .--top').after($('.newsletter.--black .--consent'));
    },
    [2, 3, 4, 5],
    '.newsletter',
  );

  App.run(
    () => {
      if (!document.querySelector('.setMobileGrid + #menu_contact')) {
        const clonedContact = document.querySelector('#menu_contact').cloneNode(true);
        clonedContact.querySelector('.footer__link.--social').remove();

        document.querySelector('.setMobileGrid:last-child').after(
          clonedContact,
        );
      }
    },
    [1, 2],
    '#menu_contact',
  );

  App.txt.redirectionDisabled = 'Choose your language and country';
  App.txt.redirectionOff = 'true';
  App.run(
    function initRedirections() {
      const linkParams = new URLSearchParams(window.location);
      const redirection = document.querySelector('.redirection');
      const langMap = {
        'fr': 'fre',
        'de': 'ger',
        'pl': 'pol',
      };
      const [userLang] = (navigator.language || navigator.userLanguage).split('-');

      if (linkParams.has('redirection') && linkParams.get('redirection') === 'redirected') {
        redirection.remove();
        document.cookie = 'redirection=closed';

        return;
      }

      if (document.cookie.indexOf('redirection=closed') >= 0) {
        redirection.remove();

        return;
      } 

      const selectedLang = langMap[userLang];
      const alternateShop = redirection.querySelector(`[data-lang=${selectedLang}]`);

      if (alternateShop) {
        redirection.classList.remove('d-none');
        alternateShop.classList.remove('d-none');
      }

      const deleteFn = () => {
        redirection.remove();
        document.cookie = 'redirection=closed';

        return false;
      };

      const closeButton = document.querySelector('.redirection__alert-close');
      const declineButtons = redirection.querySelectorAll('.btn.--small');

      closeButton.addEventListener('click', deleteFn);
      declineButtons.forEach((item) => item.addEventListener('click', deleteFn));
    },
    'all',
    '.redirection',
  );
};

export const AppInit = init;
